<template>
  <div id="file-drag-drop">
    <form class="file-form" ref="fileform" enctype="multipart/form-data">
      <input type="file" capture="camera" accept="image/*" id="file" ref="inputfiles" class="input-files" name="file" multiple/>
      <div v-if="filesSize === 0" class="files-upload">
        <label for="file" class="drop-files">
          <v-icon size="60px">mdi-upload</v-icon><br/>
          <strong class="input-select">Selecione arquivos ou arraste e os solte aqui!</strong>
        </label>
      </div>
      <template v-else>
        <v-row dense class="pa-4">
          <v-col cols="6" sm="4" md="3" lg="2" v-for="(file, key) in files" :key="key">
            <v-card flat>
              <v-img dark color="primary" class="py-3" :src="file.src" :aspect-ratio="1">
                <v-row dense>
                  <v-col cols="12" class="text-center">
                    <v-icon color="secondary" size="50" v-if="file.src === 'file'">{{ functions.getMediaIcon(file.type) }}</v-icon>
                  </v-col>
                </v-row>
              </v-img>
              <v-card-title>
                <span class="d-block truncate-text" v-html="file.name"/>
              </v-card-title>
              <v-card-text>
                <v-progress-linear v-if="file.progress > 0" v-model="file.progress"/>
              </v-card-text>
              <v-card-text>
                <span class="d-block" v-html="file.type"/>
                <span class="d-block" v-html="functions.formatBytes(file.size)"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </form>
  </div>
</template>

<script>
import { SERVER_URL } from '@/services/resources'
import functions from '@/components/Utils/Class/functions.js'
import Compressor from 'compressorjs'

export default {
  name: 'mediaUpload',
  props: {},
  data: function () {
    return {
      // Define se o navegador suporta ou não o drag and drop
      // de mídias
      dragAndDropCapable: false,

      // Array das mídias que serão feitas upload
      files: {},

      // Funções úteis
      functions: functions
    }
  },
  methods: {
    /**
     * Determina se o navegador suporta ou não os eventos de drag
     * and drop, bem como se o window possui os objetos `FormData`
     * e `FileReader` para possibilitar upload com AJAX
     * @return {Boolean}
     */
    determineDragAndDropCapable: function () {
      // Cria um elemento de teste para avaliar se certos eventos
      // estão presentes para possibilitar o drag and drop
      const div = document.createElement('div')

      /*
        Verifica se os eventos `draggable` ou `ondragstart` e `ondrop` estão
        presentes no elemento. Caso estejam, então é possivel fazer o
        drag and drop. Também verifica se no window os objetos `FormData` e `FileReader` estão
        presentes para possibilitar upload com AJAX
      */
      return (('draggable' in div) ||
            ('ondragstart' in div && 'ondrop' in div)) &&
            'FormData' in window &&
            'FileReader' in window
    },
    /**
     * Verifica se o navegador suporta drag and drop, escuta pelos eventos,
     * pega os arquivos que foram feito drag and drop e adiciona-os ao array para
     * upload
     */
    dragAndDropActionFiles: function () {
      // Verifica se a funcionalidade de drag and drop é suportada pelo
      // navegador
      this.dragAndDropCapable = this.determineDragAndDropCapable()

      // Se o drag and drop é suportado, então passa para a captura dos
      // eventos nos elementos do template
      if (this.dragAndDropCapable) {
        // Array com todos os eventos de drag
        const events = ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop']

        // Escuta todos os eventos de drag e atribui um event listener para
        // cada um no elemento form
        events.forEach(function (evt) {
          // Para cada evento adiciona um listener que previne a ação default
          // (que abre o arquivo/mídia no browser em nova aba) e impede a propagação do evento,
          // assim nenhum outro elemento abre o arquivo no browser em nova aba
          this.$refs.fileform.addEventListener(evt, function (e) {
            e.preventDefault()
            e.stopPropagation()
          }, false)
        }.bind(this))

        // Adiciona um event listener para o evento drop no elemento form
        // e liga este event listener a este component para não ser acessado
        // externamente, além de possibilitar referenciar o component diretamente
        this.$refs.fileform.addEventListener('drop', function (e) {
          // Pega os arquivos/mídias do evento de drop e adiciona-os ao array para
          // upload
          Object.keys(e.dataTransfer.files).map((key) => {
            const item = e.dataTransfer.files[key]
            item.src = ''
            // Utiliza a função set do Vue pois Object.observer e nem objetos possuem
            // reatividade para novas propriedades, apenas as antigas
            this.$set(this.files, Math.floor((Math.random() * 10000000) + 1), item)
            this.$forceUpdate()
            this.getImagePreviews()
          })

          // Realiza o upload das mídias para o servidor
          this.submitMedias()
        }.bind(this))
      }
    },
    /**
     * Realiza o upload de arquivos/mídias através da seleção de arquivos do
     * diretório local
     */
    inputActionFiles: function () {
      // Previne a ação default (que abre o arquivo/mídia no browser em nova aba)
      // e impede a propagação do evento
      this.$refs.fileform.addEventListener('change', function (e) {
        e.preventDefault()
        e.stopPropagation()
      }, false)

      // Adiciona um event listener para o evento change no elemento input
      // para que seja possível fazer upload de arquivos selecionando no diretório
      // local
      this.$refs.inputfiles.addEventListener('change', function (e) {
        // Pega os arquivos/mídias do evento de change e adiciona-os ao array para
        // upload
        Object.keys(e.srcElement.files).map((key) => {
          e.srcElement.files[key].src = ''
          // Utiliza a função set do Vue pois Object.observer e nem objetos possuem
          // reatividade para novas propriedades, apenas as antigas
          this.$set(this.files, Math.floor((Math.random() * 10000000) + 1), e.srcElement.files[key])
          this.$forceUpdate()
          this.getImagePreviews()
        })
        // Realiza o upload das mídias para o servidor
        this.submitMedias()
        this.$refs.inputfiles.value = ''
      }.bind(this))
    },
    /**
     * Define uma preview para mídias
     */
    getImagePreviews: function () {
      // Intera o array/objeto de mídias e gera uma prévia para cada uma
      Object.keys(this.files).map((key) => {
        // Avalia se a mídia é do tipo image
        if (this.files[key].type.split('/')[0] === 'image') {
          // Cria um novo objeto FileReader
          const reader = new FileReader()

          // Adiciona um event listener para que quando o arquivo for carregado
          // atualizar o src na prévia da mídia
          reader.addEventListener('load', function () {
            this.files[key].src = reader.result

            // Força a atualização do component para que as mídias preview
            // recebam a alteração do src dos arquivos
            this.$forceUpdate()
          }.bind(this), false)

          // Lê os dados para a mídia com o reader. Quando estes forem carregados,
          // escuta-se o evento propagado e atribui ao src da mídia o que foi carregado
          // pelo reader
          reader.readAsDataURL(this.files[key])
        } else {
          // Ao utilizar o nextTick, a operação só será realizada após o DOM ser renderizado
          this.$nextTick(function () {
            this.files[key].src = 'file'

            // Força a atualização do component para que as mídias preview
            // recebam a alteração do src dos arquivos
            this.$forceUpdate()
          })
        }
      })
    },
    /**
     * Realiza o upload das mídias
     */
    submitMedias: function () {
      // Intera o array de mídias e atribui cada uma ao form data
      Object.keys(this.files).map((key) => {
        // Inicializa o form data
        const formData = new FormData()

        // Mídia  a ser feito upload
        const file = this.files[key]
        const vm = this

        if (functions.isNotImage(file.type)) {
          vm.$delete(vm.files, key)
          vm.$toasted.global.error({ message: 'Upload incorreto de arquivo com formato não suportado, por favor enviar uma imagem!' })

          return
        }

        // eslint-disable-next-line no-new
        new Compressor(file, {
          quality: 0.8,
          maxWidth: 1000,
          success (compressedFile) {
            // Força a atualização dos dados do component
            vm.$forceUpdate()

            formData.append('file', compressedFile)
            if (typeof vm.files[key].progress === 'undefined') {
              vm.$http.post(SERVER_URL + '/v1/file/upload', formData, {
                // Seta o header para a requisição reconhecer que
                // está sendo feito um upload de algum arquivo/mídia
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                // Seta o progresso em uma propriedade da mídia presente no array de uploads
                // e que está sendo feito upload e força a atualização dos dados do component
                uploadProgress: function (progressEvent) {
                  if (typeof vm.files[key] !== 'undefined') {
                    vm.files[key].progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                    vm.$forceUpdate()
                  }
                }
              })
                .then((response) => {
                  // Mostra uma mensagem que o upload foi realizado com sucesso
                  // e retira a mídia do array de uploads
                  vm.$toasted.global.success({ message: 'Upload realizado com sucesso!' })
                  const outputUrl = window.URL.createObjectURL(compressedFile)
                  const fileBackEnd = response.body.file
                  fileBackEnd.path = outputUrl
                  vm.$delete(vm.files, key)

                  vm.$emit('newUpload', fileBackEnd)
                })
                .catch((error) => {
                  // Caso a requisição não tenha sido cancelada, mostra a
                  // mensagem de erro em um toast e retira a mídia do array de uploads
                  vm.$toasted.global.error({ message: error.body.message })
                  vm.$delete(vm.files, key)
                })
            }
          },
          error (error) {
            console.log('Erro ao fazer compressão', error)
          }
        })
      })
    }
  },
  mounted: function () {
    this.dragAndDropActionFiles()
    this.inputActionFiles()
  },
  computed: {
    /**
     * Retorna a quantidade atual de arquivos/mídias no array/objeto files
     */
    filesSize: function () {
      return Object.keys(this.files).length
    }
  }
}
</script>

<style scoped>
  .file-form {
    min-height: 200px;
    background-color: #ddd;
    border: 1px dashed rgba(0, 0, 0, .2);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    color: #484848;
  }

  /* .file-form:hover {
    cursor: pointer;
  } */

  .drop-files {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
  }

  .drop-files:hover {
    cursor: pointer;
  }

  .input-files {
    position: absolute;
    z-index: -1;
  }

  .input-select:hover {
    color: rgb(37, 154, 223);
    cursor: pointer;
  }
  .files-upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .truncate-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 200px;
  }

  .icon-file {
    font-size: 110px;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
  }

  .btn-remove {
    z-index: 10;
  }
</style>
